/**
 * actionType.js
 *
 * @Author: jruif
 * @Date: 2017/7/17 下午6:00
 */
import { actionCreator } from '../util/redux-tool';

export const actionType = {
  updateCommon: 'update_common',
  filterMenu: 'filter_menu',
  updateMenu: 'update_menu',
  filterMcnMenu: 'filter_mcn_menu',
  updateMcnMenu: 'update_mcn_menu',
  filterAuthMenu: 'filter_auth_menu',
  updateAuthMenu: 'update_auth_menu',
  updateAuthAccountInfo: 'update_auth_account_info',
  updateStatistics: 'update_statistics',
  updateNotice: 'update_notice',
  updateMsg: 'update_Message',
  initSubData: 'init_subscribe_data',
  updateContentManager: 'update_content_manager',
  updateReprodManager: 'update_reprod_manager',
  updateAssetManager: 'update_asset_manager',
  updateShortNews: 'update_short_news',
  updatePhoneCaptchaCode: 'update_phone_captchaCode',
  updateMcnContent: 'update_mcn_content',
  updateMcnMember: 'update_mcn_member',
  updateMcnIncome: 'update_mcn_income',
  updateMcnStatistic: 'update_mcn_statistic',
  updateMcnPush: 'update_mcn_push',
  updateMcnPushApply: 'update_mcn_push_apply',
  updateMcnRecommend: 'update_mcn_recommend',
  updateMcnRecommendApply: 'update_mcn_recommend_apply',
  updateMcnHeadline: 'update_mcn_headline',
  updateMcnHeadlineApply: 'update_mcn_headline_apply',
  updateMcnSelf: 'update_mcn_self',
  updateMcnSelfApply: 'update_mcn_self_apply',
  updateAchievement: 'update_achievement',
  updateCreditHistory: 'update_credit_history',
  initFetchData: 'init_fetch_data', // 内容同步页面
  initContentData: 'init_content_data', // 内容同步页面
  initPushData: 'init_push_data', // push中心
  initIndexStarData: 'init_index_star_data', // push中心
  initCommentData: 'init_comment_data', // 跟贴
  initCommentDetail: 'init_comment_detail', // 跟贴详情
  initLiveData: 'init_live_data', // 直播
  initIncomeData: 'init_income_data', // 直播
  initAskData: 'init_ask_data', // 我的问吧
  initProfitData: 'init_profit_data', // 我的收益
  initSpIncomeData: 'init_spIncome_data', // 特殊收益
  initActivityIncomeData: 'init_activityIncome_data', // 活动收益
  initAccountState: 'init_account_state', // 账号状态
  initDataChart: 'init_data_chart', // 数据详情
  initIssueManage: 'init_issue_manage', // 问答管理
  updateLabHot: 'update_lab_hot',
  updateLabPoi: 'update_lab_poi',
  updateLabPiyao: 'update_lab_piyao',
  updateRecognition: 'update_recognition',
  initMcnLevel: 'init_mcn_level',
  initMcnIncomeData: 'init_mcn_income_data',
  initCustomerFaqs: 'init_customer_faqs',
  initFeedbackList: 'init_feedback_list',
  updateProtection: 'update_protection', // 原创保护
  updateVideoProtection: 'update_video_protection', // 视频原创保护
  updateComplaint: 'update_complaint', // 我的举报 Complaint
  updateWhitelist: 'update_whitelist', // 易剑联盟白名单
  updateCustomTab: 'update_customTab', // 自定义tab主页
  updateRightsManage: 'update_rightsManage', // 易剑联盟维权管理
  updateInfringedContent: 'update_infringedContent', // 易剑联盟被侵权内容
  updateContentDetail: 'update_contentDetail', // 易剑联盟被侵权内容 详情
  updateAlliance: 'update_alliance', // 易剑联盟
  updateCopyDetail: 'update_copy_detail', // 举报详情
  updateVideoCopyDetail: 'update_video_copy_detail', // 视频举报详情
  updateTaskData: 'update_task_data', // 任务
  updateVideoData: 'update_video_data', // 发布视频页面
  updateVideoTranslate: 'update_video_translate', // 发布视频页面
  updateGalleryData: 'update_gallery_data', // 发布图集页面
  updateArticleData: 'update_article_data', // 发布文章页面
  updatePostAssistentData: 'update_post_assistent_date', // 发文助手
  updateDeveloperInfo: 'update_developer_info',
  updatePlayList: 'update_play_list', // 播单列表
  updatePlayData: 'update_play_data', // 创建播单
};
// 常规同步action，异步action可参考'./action-index.js'文件
const action = {};

Object.keys(actionType).forEach(type => {
  action[type] = actionCreator(actionType[type]);
});

action.batchUpdateVideoData = (id, value) => ({
  type: 'update_batch_data',
  id,
  value,
});
action.batchOverideVideoData = (id, value) => ({
  type: 'overide_batch_data',
  id,
  value,
});
action.batchUpdateVideoTranslate = (id, value) => ({
  type: 'update_batch_data',
  id,
  value: {
    videoTranslate: value,
  },
});
action.batchDelVideo = id => ({
  type: 'del_batch_data',
  id,
});
action.batchRestVideo = id => ({
  type: 'reset_batch_data',
  id,
});
action.batchAddVideo = (id, value) => ({
  type: 'add_batch_data',
  value,
  id,
});

export default action;
